const createConnectionBanner = () => {
    let banner = document.querySelector('[data-ff-connection-banner]');

    if (banner) {
        return banner;
    }

    banner = document.createElement('div');
    banner.dataset.ffConnectionBanner = '';
    banner.setAttribute('role', 'status');
    banner.setAttribute('aria-live', 'polite');
    banner.className = 'fixed inset-x-0 bottom-0 z-[9999] hidden border-t border-amber-300 bg-amber-50 px-4 py-3 text-center text-sm font-semibold text-amber-950 shadow-lg dark:border-amber-500/30 dark:bg-amber-950 dark:text-amber-100';
    banner.textContent = 'You’re offline. Some FestFriends features will update when your connection returns.';
    document.body.appendChild(banner);

    return banner;
};

const updateConnectionState = () => {
    const banner = createConnectionBanner();
    banner.classList.toggle('hidden', navigator.onLine);

    document.documentElement.dataset.connection = navigator.onLine ? 'online' : 'offline';
};

window.addEventListener('online', updateConnectionState);
window.addEventListener('offline', updateConnectionState);

document.addEventListener('DOMContentLoaded', () => {
    updateConnectionState();
});

if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
            registration.update().catch(() => {});
        } catch (error) {
            console.warn('FestFriends service worker registration failed.', error);
        }
    });
}
